// extracted by mini-css-extract-plugin
export var indeterminate = "_2a-6";
export var md = "_2a-5";
export var semantic = "_2a-7";
export var sm = "_2a-4";
export var text = "_2a-8";
export var toggleControl = "_2a-0";
export var toggleInput = "_2a-1";
export var toggleSwitch = "_2a-2";
export var xs = "_2a-3";